import axios from 'axios'
import {Response} from '@/domain/Common'
import env from '@/util/Env'

export class PortfolioSituationService {
  public static async getSituations()
    : Promise<PortfolioSituations> {
    return axios
      .get<Response<PortfolioSituations>>(
        `${env.ApiUrl}/public/portfolio/situations`,
        {},
      )
      .then((res) => {
        return res.data.result
      })
  }
}

export interface PortfolioSituations {
  situations: PortfolioSituation[]
}

export interface PortfolioSituation {
  situationCode: string,
  ratio: number
}
